import Vue from "vue";
import app from "./app.vue";
import fastclick from "fastclick";
import "@/assets/js/common/kksa_kuaikanapp.js";
import h5init from "@kkmh/h5init";

import "@/assets/css/public/flex.css";
fastclick.attach(document.body);
window.h5init = h5init;
//预渲染图片
let imgList = [
    require("./img/error.png"),
    require("./img/tab-bg.png"),
    require("./img/header.png"),
];

const imgPreloader = url => {
    return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = url;
        image.onload = () => {
            resolve();
        };
        image.onerror = () => {
            resolve();
            //reject();
        };
    });
};
const imgsPreloader = imgs => {
    let promiseArr = [];
    imgs.forEach(element => {
        promiseArr.push(imgPreloader(element));
    });
    return Promise.all(promiseArr);
};
imgsPreloader(imgList);
(async () => {
    // 提前请求 客户端协议 初始化window.__gvalkkmh
    await h5init({ login_mode: "unwanted" });
    new Vue({
        el: "#app",
        components: {
            app
        },
        template: "<app/>"
    });
})();


// WEBPACK FOOTER //
// ./src/pages/act/202102/link_vip/index.js